<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Transaction Details</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                    </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;">
                        <v-layout row style="border: 1px solid lightgray;margin-bottom:4px;">
                            <v-flex xs9 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Transaction Id : </span> 
                                <span> {{ Transaction_Details.Transaction_Id }} </span>
                            </v-flex>
                            <v-flex xs3 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Date : </span> 
                                <span> {{ new Date(Transaction_Details.Transaction_Date).toLocaleDateString() }} </span>
                            </v-flex>
                        </v-layout> 
                        <v-flex pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Purchaser Email : </span> 
                           <span> {{ Transaction_Details.Email }} </span>
                        </v-flex>            
                        <!-- <v-flex pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Course Title : </span> 
                           <span> {{ Transaction_Details.Course_Title }} </span>
                        </v-flex>
                        <v-flex pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Course Type : </span> 
                           <span> {{ Transaction_Details.Course_Type }} </span>
                        </v-flex> -->
                        <v-flex pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Applied Coupon : </span> 
                           <span> {{ Transaction_Details.Applied_Offer ? Transaction_Details.Applied_Offer : "Coupon Not Applied" }} </span>
                        </v-flex>
                        <v-layout row style="border: 1px solid lightgray;margin-bottom:4px;">
                            <v-flex xs4 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Price : </span> 
                                <span>Rs. {{ Transaction_Details.Actual_Amount }} </span>
                            </v-flex>
                            <v-flex xs4 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Discount : </span> 
                                <span>Rs. {{ Transaction_Details.Discount }} </span>
                            </v-flex>
                            <v-flex xs4 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Amount Paid : </span> 
                                <span>Rs. {{ Transaction_Details.Discounted_Amount }} </span>
                            </v-flex>
                        </v-layout>
                        <v-flex class="clsforCourses" v-for="item in Transaction_Details['Items']" :key="item._id">
                            <section v-if="item.Purchase_Type == 'Course'">
                                <img style="height: 150px;width: 200px;" :src="item.Course_Image"/>
                                <v-flex style="font-weight: 900;">{{ item.Course_Title }}</v-flex>
                                <v-flex style="font-weight: 900;">Course Type : {{ CourseTypeLabel(item.Course_Type) }}</v-flex>
                            </section>
                            <section v-else-if="item.Purchase_Type == 'Project'">
                                <img style="height: 150px;width: 200px;" :src="item.Project_Banner"/>
                                <v-flex style="font-weight: 900;">{{ item.Project_Title }}</v-flex>
                            </section>
                        </v-flex>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { CourseTypeLabel } from '../../util/courseTypes'

export default {
    props: ['dialog'],
    data(){
        return {
            Transaction_Details : {}
        }
    },
    methods:{
        CourseTypeLabel,
        CloseDialog(){

            this.$emit('close')
        },
        DisplayDetails(Item){
            this.Transaction_Details = Item
            console.log(Item)
        }    
    }
}
</script>
<style scoped>
.flexPadding{
    padding: 8px;
}
.clsforCourses{
    width: 45.3%;
    margin: 10px;
    display: inline-block;
    -webkit-box-shadow: 0 0 6px 2px rgba(0,0,0,.16);
    box-shadow: 0 0 6px 2px rgba(0,0,0,.16);
    padding: 10px;
    text-align: center;
}
</style>